import { toast } from "sonner";

export const JD_TEMPLATE_VIEW_URL =
  "https://docs.google.com/presentation/d/11O8vXUnRllfHOQ6sUXX-qu4e1a_hDqv1/edit";
export const JD_TEMPLATE_DOWNLOAD_URL =
  "https://docs.google.com/presentation/d/11O8vXUnRllfHOQ6sUXX-qu4e1a_hDqv1/export/pptx";

const ACCEPTED =
  ".pdf,.doc,.docx,.ppt,.pptx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation";

export default function JdUpload({ form, setForm }) {
  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 10 * 1024 * 1024) {
      toast.error("JD file must be under 10 MB");
      e.target.value = "";
      return;
    }
    const buf = await file.arrayBuffer();
    const bytes = new Uint8Array(buf);
    let bin = "";
    for (let i = 0; i < bytes.length; i += 0x8000) {
      bin += String.fromCharCode.apply(null, bytes.subarray(i, i + 0x8000));
    }
    const b64 = btoa(bin);
    setForm({
      ...form,
      jd_file_b64: b64,
      jd_filename: file.name,
      jd_mime: file.type || "application/octet-stream",
    });
    toast.success(`Attached ${file.name}`);
  };

  const clear = () => {
    setForm({ ...form, jd_file_b64: "", jd_filename: "", jd_mime: "" });
  };

  return (
    <div className="border border-rule bg-paper p-4">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-quiet">Job description (optional)</div>
          <p className="text-xs text-quiet mt-1.5 max-w-md">
            Upload your JD as PDF, DOCX, or PPTX (max 10 MB). Don't have one yet?
            Use our template below — fill it, save, and re-upload.
          </p>
        </div>
        <div className="flex gap-2">
          <a
            data-testid="jd-template-view"
            href={JD_TEMPLATE_VIEW_URL}
            target="_blank"
            rel="noreferrer"
            className="border border-ink hover:bg-white px-3 py-1.5 text-xs font-mono uppercase tracking-wider text-ink"
          >
            View template ↗
          </a>
          <a
            data-testid="jd-template-download"
            href={JD_TEMPLATE_DOWNLOAD_URL}
            target="_blank"
            rel="noreferrer"
            className="bg-ink hover:bg-black text-white px-3 py-1.5 text-xs font-mono uppercase tracking-wider"
          >
            Download .pptx ↓
          </a>
        </div>
      </div>

      <div className="mt-4 pt-4 border-t border-rule">
        {form.jd_filename ? (
          <div className="flex items-center justify-between gap-3 bg-white border border-rule px-3 py-2">
            <div className="min-w-0">
              <div className="font-mono text-[10px] uppercase tracking-wider text-[#10B981]">Attached</div>
              <div className="text-sm text-ink truncate" data-testid="jd-attached-filename">{form.jd_filename}</div>
            </div>
            <button
              type="button"
              data-testid="jd-clear-btn"
              onClick={clear}
              className="text-xs font-mono uppercase tracking-wider text-quiet hover:text-[#EF4444] border border-rule hover:border-[#EF4444] px-2 py-1"
            >
              Remove
            </button>
          </div>
        ) : (
          <label className="block">
            <span className="font-mono text-[10px] uppercase tracking-wider text-quiet">Upload JD file</span>
            <input
              data-testid="jd-file-input"
              type="file"
              accept={ACCEPTED}
              onChange={onFile}
              className="block w-full mt-1.5 text-sm text-quiet file:mr-3 file:py-1.5 file:px-3 file:border file:border-ink file:bg-white file:text-ink file:font-mono file:text-xs file:uppercase file:tracking-wider file:cursor-pointer hover:file:bg-paper"
            />
          </label>
        )}
      </div>
    </div>
  );
}
